const MonitoringType = {
  COMPANY: 1,
  RESPONSE: 2,
};

export default MonitoringType;
